import { render, staticRenderFns } from "./PolicyFormSource.vue?vue&type=template&id=3904eb6d&scoped=true&"
import script from "./PolicyFormSource.vue?vue&type=script&lang=ts&"
export * from "./PolicyFormSource.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyFormSource.vue?vue&type=style&index=0&id=3904eb6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3904eb6d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
